import {
  Breadcrumb,
  Dropdown,
  Empty,
  Flex,
  Form,
  message,
  Modal,
  Select,
  Space,
  Spin,
  Table,
  Typography,
  Tooltip,
  Popconfirm,
  Descriptions,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useFieldArray, useForm } from "react-hook-form";
import { Button, Icon, Row } from "../../../components/Component";
import {
  Alert,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import FormInput from "../../form-components/InputComponent";
import FormSelect, {
  SelectOption,
} from "../../form-components/SelectComponent";
import { tagRender } from "../projects/projectCreation";
import debounce from "lodash.debounce";
import { ReactTyped } from "react-typed";
import FormDatePicker from "../../form-components/DatePicker";
import FormMultiSelect from "../../form-components/MultiSelectComponent";
import {
  DownOutlined,
  LoadingOutlined,
  PlusSquareOutlined,
} from "@ant-design/icons";
import { nanoid } from "@reduxjs/toolkit";
import { getDirtyFieldsOnly } from "../../../utils/use-form/GetDirtyFieldsOnly";
import {
  ActivityFlagEnum,
  BoqLines,
  EditableCell,
  ResourceType,
} from "./ActivityCreation";
import { ApiResponse } from "../../../api/master/axiosIndex";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import {
  ActivityInDetailModal,
  updateActivityInDetailModalSlice,
} from "../../../store/slices/projectManagement/activity-view/ActivityInDetailView";
import { activityApis } from "../../../api/Activity";
import { pmsMasterApis } from "../../../api/PmsMaster";
import { projectsApis } from "../../../api/projects";
import { CustomJsonParse } from "../../../utils/convertions";
import Swal from "sweetalert2";
import { useLocation } from "react-router";
import {
  getLabel,
  OwnerChangeReason,
  StatusChangeReason,
} from "../phases/PhaseFieldDetailsUpdate";
import { useDispatch } from "react-redux";
import { getColorByLabel } from "../projects/ProjectInformationById";
import { Tag } from "antd/lib";
import {
  AddAccess,
  EditAccess,
  CancelAccess,
} from "../../../components/accessControl/AccessControl";
import { useAccessControl } from "../../../utils/useAccessControl";
const { Text } = Typography;
export interface ActivityTagsInterface {
  activityTagId: number;
  tagId: number;
  tagName: string;
}
export type ActiveBoqLines = {
  boqTargetId: number;
  boqTargetNumber: string;
  categoryId: number;
  categoryName: string;
  materialId: number;
  materialName: string;
  activityBoqId: number;
  allocateBOQQuantity: number;
  allotedQuantity: number;
  quantity: number;
  uomId: number;
  uomName: string;
  boqLineName?: string;
  siteStructureUnitName?: string;
  floorNo?: string;
  siteStructureSubUnitName?: string;
  locationName?: string;
};

interface ActivityFieldsViewProps {
  activityId?: number;
  embedded?: boolean;
  initialMode?: "edit" | "view";
  onModeChange?: (mode: string) => void;
  onClose?: () => void;
  onRefresh?: () => void;
}

const ActivityFieldsView: React.FC<ActivityFieldsViewProps> = ({
  activityId: propActivityId,
  embedded = false,
  initialMode = "view",
  onModeChange,
  onClose,
  onRefresh,
}) => {
  const dispatch = useDispatch();
  const [statusFilterData, setStatusFilterData] = useState<SelectOption[]>([]);
  const [showStatusDropDown, setShowStatusDropDown] = useState(false);

  // Get access control permissions
  const { canCancel, canEdit: hasModuleEditPermission } = useAccessControl();
  const {
    data: {
      id: reduxActivityId,
      open: activityOpen,
      projectResponse: {
        id: projectId,
        isLocked: lock,
        lockedBy: lockedBy,
        lockedByName: lockedByUserName,
        updatedDate: lockedOn,
        plannedStartDate: projectStartDate,
        plannedEndDate: projectEndDate,
        status: projectStatus,
      },
      phaseResponse: { id: phaseId, status: phaseStatus },
      extra: {
        status,
        createdAt,
        createdByUserName,
        endDate,
        ownerName,
        ownerId,
        originalActivityOwnerName,
        originalActivityOwnerId,
        reassignedReason,
      },
      allowEdit,
    },
  }: { data: ActivityInDetailModal } = useSelector(
    (state: RootState) => state.ActivityInDetailModal
  );
  const { data: currentUser } = useSelector((state: any) => state.currentUser);

  // Use prop activityId if provided (embedded mode), otherwise use Redux state
  const activityId = propActivityId || reduxActivityId;

  const location = useLocation();
  const { extra: extraData } = location.state || {};
  const { screenName, currentUserId } = extraData || {};

  const [loading, setLoading] = useState(true);
  const [originalData, setOriginalData] = useState<any>();
  const [mode, setMode] = useState<"edit" | "view">(initialMode);
  const [errorData, setErrorData] = useState<
    | {
      error: string;
      message: string;
    }
    | undefined
  >(undefined);
  const [screenSize, setScreenSize] = useState(0);
  const [messageApi, contextHolder] = message.useMessage();
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [editingKeys, setEditingKeys] = useState<string[]>([]);
  const [form] = Form.useForm();
  const isEditing = (record: any) => editingKeys.includes(record.key);
  const [originalTagIdActivityTagId, setOriginalTagIdActivityTagId] = useState<{
    [key: string]: number;
  }>({});
  const [tags, setTags] = useState<SelectOption[]>([]);
  const [deselectedTags, setDeselectedTags] = useState<any[]>([]);
  const [options, setOptions] = useState<
    { label: string; value: string | number }[]
  >([]);
  const [ownerChangeModalOpen, setOwnerChangeModalOpen] = useState<{
    open: boolean;
    extraData: any;
  }>({
    open: false,
    extraData: {},
  });
  const [statusChangeModalOpen, setStatusChangeModalOpen] = useState<{
    open: boolean;
    extraData: any;
  }>({
    open: false,
    extraData: {},
  });

  const [labourTypesList, setLabourTypesList] = useState<SelectOption[]>([]);
  const [laborCategoriesList, setLaborCategoriesList] = useState<
    SelectOption[]
  >([]);
  const [projectUsers, setProjectUsers] = useState<SelectOption[]>([]);
  const [projectTagsList, setProjectTagsList] = useState<any[]>([]);
  const [budgetLines, setBudgetLines] = useState<SelectOption[]>([]);
  const [boqLines, setBoqLines] = useState<BoqLines[]>([]);

  // Budget allocation state management
  const [selectedBudgetLine, setSelectedBudgetLine] = useState<{
    lineId: number;
    headerId: number;
    budgetId: string;
    budgetLineName: string;
    budgetValue: number;
    allocatedLineValue: number;
  } | null>(null);
  const [selectedBudgetValue, setSelectedBudgetValue] = useState<number | null>(
    null
  );

  const [activeBoqs, setActiveBoqs] = useState<ActiveBoqLines[]>([]);
  const [updatedResources, setUpdatedResources] = useState({});
  const [deletedResources, setDeletedResources] = useState<number[]>([]);
  const [boqLinesDataSource, setBoqLinesDataSource] = useState<any>([]);
  const [remainingWeightage, setRemainingWeightage] = useState<number | null>(
    null
  );
  const [boqMaterialsError, setBoqMaterialsError] = useState<
    string | undefined
  >(undefined);
  const [allocatedResourcesError, setAllocatedResourcesError] = useState<
    string | undefined
  >(undefined);
  const [resourceModal, setResourceModal] = useState<{
    open: boolean;
    title: "Add New Resource" | "Edit Resource";
    data: ResourceType;
    index: number | undefined;
  }>({
    open: false,
    title: "Add New Resource",
    data: {
      type: undefined,
    } as ResourceType,
    index: undefined,
  });
  const methods = useForm<{
    activityName: string;
    cloneActivity: boolean;
    activityStartDate: any;
    activityEndDate: any;
    projectId: number | string;
    activityId?: number | string;
    activityOwnerId?: number | string;
    activityOwnerName?: string;
    activityBudgetLineName?: string;
    activityBudgetLineId?: number | string;
    flag?: string | number;
    tags?: string[];
    boqLineIds: number[];
    activityWeightage: number;
    allocatedResources: ResourceType[];
  }>({
    mode: "onChange",
    // defaultValues: {
    //   ...extra?.defaultValues,
    // },
  });
  const {
    control,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors, dirtyFields },
  } = methods;
  const materialAllocateErrorsRef = useRef<HTMLDivElement>(null);
  const resourceAllocateErrorsRef = useRef<HTMLDivElement>(null);
  const { fields, append, update, remove }: any = useFieldArray({
    control,
    name: "allocatedResources",
  });
  const startDateWatch = watch("activityStartDate");
  const activityOwnerIdWatch = watch("activityOwnerId");
  const boqLineIdsWatch = watch("boqLineIds");
  const budgetLineIdWatch = watch("activityBudgetLineId");

  const resourcesMethods = useForm<ResourceType>({
    mode: "onChange",
    // defaultValues: {
    //   ...extra?.defaultValues,
    // },
  });

  const {
    control: resourcesControl,
    handleSubmit: resourcesHandleSubmit,
    setValue: resourcesSetValue,
    watch: resourcesWatch,
    reset: resourcesReset,
    formState: { errors: resourcesErrors, dirtyFields: resourcesDirtyFields },
  } = resourcesMethods;
  const [resourceWarning, setResourceWarning] = useState<{
    index: number | undefined;
    message: string | undefined;
  }>({
    index: undefined,
    message: undefined,
  });
  const fetchStatusFilterData = async () => {
    try {
      const response = await projectsApis.fetchStatusFiltersByModule(
        "ActivityStatusChange"
      );
      const { data, status } = response;
      if (status) {
        const options = data.map((item: any) => {
          return {
            label: item,
            value: item,
          };
        });
        setStatusFilterData(options);
      }
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };

  const fetchLabourTypesList = async () => {
    try {
      const response = await pmsMasterApis.labourTypesList();
      const { data: optionsArray, status } = response;
      if (status) {
        setLabourTypesList(
          optionsArray?.map((item: any) => ({
            value: item?.laborTypeId,
            label: item?.laborType,
          }))
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchLaborCategoriesList = async () => {
    try {
      const response = await pmsMasterApis.labourCatgoriesList();
      const { data: optionsArray, status } = response;
      if (status) {
        setLaborCategoriesList(
          optionsArray?.map((item: any) => ({
            value: item?.laborCategoryId,
            label: item?.laborCategory,
          }))
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProjectUsers = async () => {
    try {
      const response: any = await projectsApis.fetchProjectUsers(projectId);
      const {
        data: usersList,
        status,
      }: {
        status: boolean;
        data: {
          userId: string;
          userName: string;
          projectUserId: number;
          mobileNumber: string;
          roleName: string;
        }[];
      } = response || {};
      if (status) {
        const formatted = usersList?.map(
          (user: {
            userId: string;
            userName: string;
            mobileNumber: string;
            roleName: string;
          }) => ({
            label: user?.userName,
            value: +user?.userId,
            extra: {
              mobileNumber: user?.mobileNumber,
              roleName: user?.roleName,
            },
          })
        );
        setProjectUsers(formatted);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchProjectTags = async () => {
    try {
      const response: any = await projectsApis.fetchProjectTags(projectId);
      const {
        data: tagsList,
        status,
      }: {
        status: boolean;
        data: { tagName: string; tagId: number | string }[];
      } = response || {};
      if (status && Array.isArray(tagsList)) {
        setProjectTagsList(tagsList);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTagSuggestions = (search: string) => {
    const dataToSearch = projectTagsList || [];
    const filtered =
      search && search.length >= 1
        ? dataToSearch.filter((tag) =>
          tag?.tagName?.toLowerCase()?.includes(search?.toLowerCase())
        )
        : dataToSearch;

    const formatted = filtered.map((tag) => ({
      label: tag?.tagName,
      value: tag?.tagId,
    }));

    if (formatted.length === 0 && search && search.length >= 1) {
      setOptions([{ label: search, value: "newTag__" + search }]);
    } else {
      setOptions(formatted);
    }
  };

  const fetchProjectBoqs = async () => {
    try {
      const response: any = await projectsApis.fetchProjectBoqs(projectId);
      const {
        data: boqLines,
        status,
      }: {
        status: boolean;
        data: BoqLines[];
      } = response || {};
      if (status) {
        setBoqLines(boqLines);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBudgetLines = async (startDate?: any, endDate?: any) => {
    try {
      const params: any = {
        bom: "N",
      };

      // Add date parameters if both dates are provided
      if (startDate && endDate) {
        params.startDate = startDate.format("YYYY-MM-DD");
        params.endDate = endDate.format("YYYY-MM-DD");
      }

      const response: any = await projectsApis.fetchBudgetLines(
        projectId,
        params
      );
      const {
        data: bgtLines,
        status,
      }: {
        status: boolean;
        data: {
          lineId: Number;
          headerId: Number;
          budgetId: string;
          budgetLineName: string;
          budgetValue: Number;
        }[];
      } = response || {};
      if (status) {
        setBudgetLines(
          bgtLines?.map((line: any) => ({
            label: line?.budgetLineName,
            value: line?.lineId,
            extra: {
              budgetValue: line?.budgetValue,
              allocatedLineValue: line?.allocatedLineValue,
              budgetId: line?.budgetId,
              budgetLineName: line?.budgetLineName,
            },
          }))
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const validateResources = (source: ResourceType[], target: ResourceType) => {
    try {
      const { laborTypeId, laborCategoryId } = target;

      for (let i = 0; i < source?.length; i++) {
        const resource = source[i];
        if (
          Number(resource.laborTypeId) === Number(laborTypeId) &&
          Number(resource.laborCategoryId) === Number(laborCategoryId)
        ) {
          setResourceWarning({
            index: source.length,
            message: "An identical resource entry already exists.",
          });
          return false;
        }
      }
      return true;
    } catch (error) {
      console.log("error", error);
      return false;
    }
  };

  const resourceModalCancel = () => {
    setResourceModal({
      open: false,
      title: "Add New Resource",
      data: {
        laborTypeId: undefined,
        labourTypeName: "",
        laborCategoryId: undefined,
        laborCategory: "",
      },
      index: undefined,
    });
    setResourceWarning({ index: undefined, message: undefined });
    resourcesReset({
      laborTypeId: undefined,
      labourTypeName: "",
      laborCategoryId: undefined,
      laborCategory: "",
    });
  };

  useEffect(() => {
    if (boqLineIdsWatch) {
      const filteredData: any = [];
      const allocationByKey: Record<string, any> = {};
      activeBoqs?.forEach((alloc: any) => {
        if (alloc?.key) {
          allocationByKey[alloc.key] = alloc;
        }
      });
      boqLineIdsWatch?.forEach((id: any) => {
        const boqLine: any = boqLines?.find(
          (item: any) => item.boqTargetId == id
        );
        const { lines, boqTargetId, boqTargetNumber, boqTargetName, boqTitle } =
          boqLine || {};
        if (boqLine) {
          const boqLines = lines?.map((line: any) => {
            const {
              targetId,
              targetLineId,
              materialId,
              categoryId,
              uomId,
              boqLineId,
              boqLineName,
            } = line;
            // Use targetLineId when available (matches what we persist as
            // boqTargetLineId on save and what the API returns on reload).
            const lineKeyPart = targetLineId ?? targetId;
            const key =
              id +
              "~~" +
              lineKeyPart +
              "~~" +
              categoryId +
              "~~" +
              materialId +
              "~~" +
              uomId +
              (boqLineId ? "~~" + boqLineId : "");
            const existingAllocation = allocationByKey[key];
            return {
              ...line,
              boqTargetId,
              boqTargetNumber,
              boqTitle,
              boqLineId,
              boqLineName,
              key,
              allotedQuantity: existingAllocation?.allotedQuantity,
              allocateBOQQuantity:
                existingAllocation?.allocateBOQQuantity ??
                existingAllocation?.allotedQuantity,
              activityBoqId: existingAllocation?.activityBoqId,
            };
          });
          filteredData.push(...boqLines);
        }
      });
      setBoqLinesDataSource(filteredData);

      // In edit mode, pre-select & pre-edit rows that already have an
      // allocation so the user can see the existing values in editable
      // inputs and the save diff logic picks them up correctly.
      if (mode === "edit") {
        const existingKeys = filteredData
          .filter((row: any) => row?.allotedQuantity != null)
          .map((row: any) => row.key);
        setSelectedRowKeys(existingKeys);
        setEditingKeys(existingKeys);
        const fieldValues: Record<string, any> = {};
        filteredData.forEach((row: any) => {
          if (row?.allotedQuantity != null) {
            fieldValues[`allocateBOQQuantity_${row.key}`] = +row.allotedQuantity;
            fieldValues[`allotedQuantity_${row.key}`] = +row.allotedQuantity;
          }
        });
        if (Object.keys(fieldValues).length) {
          form.setFieldsValue(fieldValues);
        }
      }
    }
  }, [boqLineIdsWatch, boqLines, activeBoqs, mode, form]);

  // Handle budget line selection to update budget value
  useEffect(() => {
    if (budgetLineIdWatch && budgetLines.length > 0) {
      const selectedBudget = budgetLines.find(
        (budget) => budget.value === budgetLineIdWatch
      );
      if (selectedBudget?.extra) {
        setSelectedBudgetValue(selectedBudget.extra.budgetValue);
        setSelectedBudgetLine({
          lineId: selectedBudget.value as number,
          headerId: 0, // Not needed for display
          budgetId: selectedBudget.extra.budgetId,
          budgetLineName: selectedBudget.extra.budgetLineName,
          budgetValue: selectedBudget.extra.budgetValue,
          allocatedLineValue: selectedBudget.extra.allocatedLineValue,
        });
      }
    } else {
      setSelectedBudgetValue(null);
      setSelectedBudgetLine(null);
    }
  }, [budgetLineIdWatch, budgetLines]);

  const onSelectChange = (
    newSelectedRowKeys: React.Key[],
    selectedRows?: any
  ) => {
    setSelectedRowKeys(newSelectedRowKeys);
    if (!newSelectedRowKeys) {
      setEditingKeys(() => []);
    }
    const editableRowKeys: any = [];
    newSelectedRowKeys?.forEach((key) => {
      const selectedRow = selectedRows.find((row: any) => row.key === key);
      editableRowKeys.push(key);
      if (selectedRow?.allocateBOQQuantity) {
        form.setFieldsValue({
          [`allocateBOQQuantity_${key}`]: selectedRow?.allocateBOQQuantity,
        });
      }
    });
    setEditingKeys(editableRowKeys);
  };

  const viewChange = () => {
    setScreenSize(window.innerWidth);
  };

  const debouncedFetch = debounce(fetchTagSuggestions, 100);
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const CollapsePanel = ({ mode = "view" }) => {
    const boqColumns = [
      {
        title: "BOQ Title",
        dataIndex: "boqTargetNumber",
        key: "boqTargetNumber",
        width: 100,
        fixed: "left",
        render: (text: any, record: any) =>
          record?.boqTitle || record?.boqTargetNumber,
      },
      {
        title: "BOQ Line Name",
        dataIndex: "boqLineName",
        key: "boqLineName",
        width: 200,
        render: (text: any, record: any) => {
          const hasSiteHierarchyData =
            record?.siteStructureUnitName ||
            record?.floorNo ||
            record?.siteStructureSubUnitName ||
            record?.locationName;

          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <span>{record?.boqLineName || "N/A"}</span>
              {hasSiteHierarchyData && (
                <Popconfirm
                  placement="right"
                  title={<></>}
                  icon={<></>}
                  showCancel={false}
                  trigger="hover"
                  okButtonProps={{
                    style: {
                      display: "none",
                    },
                  }}
                  description={
                    <div className="d-flex flex-column">
                      <Descriptions
                        title=""
                        bordered
                        column={1}
                        size="small"
                        className="custom-description-title"
                      >
                        {record?.siteStructureUnitName && (
                          <Descriptions.Item label="Tower / Block">
                            {record.siteStructureUnitName}
                          </Descriptions.Item>
                        )}
                        {record?.floorNo && (
                          <Descriptions.Item label="Floor">
                            {record.floorNo}
                          </Descriptions.Item>
                        )}
                        {record?.siteStructureSubUnitName && (
                          <Descriptions.Item label="Flat">
                            {record.siteStructureSubUnitName}
                          </Descriptions.Item>
                        )}
                        {record?.locationName && (
                          <Descriptions.Item label="Location">
                            {record.locationName}
                          </Descriptions.Item>
                        )}
                      </Descriptions>
                    </div>
                  }
                >
                  <Icon
                    name="info"
                    className="ms-1"
                    style={{
                      color: "#004293",
                      cursor: "pointer",
                      fontSize: "16px",
                    }}
                  />
                </Popconfirm>
              )}
            </div>
          );
        },
      },
      {
        title: "Category ",
        dataIndex: "categoryName",
        key: "categoryName",
        width: 150,
      },
      {
        title: "Material ",
        dataIndex: "materialName",
        key: "materialName",
        width: 200,
      },
      {
        title: "BOQ Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 150,
        hidden: mode === "view",
        render: (text: any, record: any) => `${Number(text)} ${record.uomName}`,
      },
      {
        title: "Activity Available Qty",
        dataIndex: "activityAvailableQty",
        key: "activityAvailableQty",
        width: 180,
        hidden: mode === "view",
        render: (text: any, record: any) =>
          text !== undefined && text !== null
            ? `${Number(text)} ${record.uomName}`
            : "N/A",
      },
      {
        title: "Allocated Qty",
        dataIndex: "allotedQuantity",
        key: "allotedQuantity",
        width: 200,
        editable: true,
        render: (text: any, record: any) => {
          if (text === undefined || text === null || text === "") {
            return mode === "view" ? "N/A" : <div></div>;
          }
          return `${Number(text)} ${record.uomName || ""}`.trim();
        },
        onCell: (record: any) => ({
          record,
          inputType: "number",
          dataIndex: "allotedQuantity",
          title: "Allocate Qty",
          editing: isEditing(record),
        }),
      },
    ];
    const resourceColumns: any = [
      {
        title: "Labour Type",
        dataIndex: "labourTypeName",
        key: "labourTypeName",
        width: 200,
      },
      {
        title: "Labour Category",
        dataIndex: "laborCategory",
        key: "laborCategory",
        width: 200,
      },
      {
        title: "Action",
        key: "action",
        fixed: "right",
        width: 90,
        hidden: mode === "view",
        render: (text: any, record: ResourceType, index: number) => (
          <>
            <EditAccess moduleName="Activities">
              <Button
                size="sm"
                type="button"
                onClick={() => {
                  // Reset form with existing values to properly track dirty fields
                  resourcesReset({
                    laborTypeId: record?.laborTypeId,
                    labourTypeName: record?.labourTypeName,
                    laborCategoryId: record?.laborCategoryId,
                    laborCategory: record?.laborCategory,
                    activityResourceId: record?.activityResourceId,
                  });
                  setResourceModal((pre) => ({
                    ...pre,
                    open: true,
                    title: "Edit Resource",
                    data: {
                      ...record,
                    },
                    index: index,
                  }));
                }}
              >
                <Icon name="edit" />
              </Button>
            </EditAccess>
            <Button
              size="sm"
              type="button"
              onClick={() => {
                remove(index);
                if (record?.activityResourceId) {
                  setDeletedResources((pre: any) => [
                    ...pre,
                    record?.activityResourceId,
                  ]);
                  setUpdatedResources((pre: any) => {
                    let updatedObj: any = {
                      ...pre,
                    };
                    delete updatedObj[record?.activityResourceId || ""];
                    return updatedObj;
                  });
                }
              }}
            >
              <Icon name="trash" />
            </Button>
          </>
        ),
      },
    ];
    if (mode === "view") {
      return (
        <div className="mt-3">
          <h6 className="title">Resources Allocated</h6>
          <div
            style={
              embedded
                ? { width: "100%" }
                : { width: screenSize - 120 + "px", margin: "10px auto" }
            }
          >
            <Table
              rowKey={nanoid()}
              columns={resourceColumns}
              dataSource={fields}
              pagination={false}
              bordered
              size="middle"
              scroll={{
                x: 1260,
              }}
            />
          </div>
          <h6 className="title mt-3">Allocated Materials</h6>
          <div className="table-responsive poTable">
            <div
              style={
                embedded
                  ? { width: "100%" }
                  : { width: screenSize - 120 + "px", margin: "0px auto" }
              }
            >
              <Table
                className="customTable"
                columns={boqColumns as any}
                dataSource={activeBoqs}
                scroll={{ x: 1000 }}
                bordered
                size="middle"
                pagination={false}
              />
            </div>
          </div>
        </div>
      );
    }
    return (
      <>
        <span ref={resourceAllocateErrorsRef}></span>
        <div className="d-flex align-items-end justify-content-between mt-4 mb-3">
          <h6 className="mb-0">Resources Allocated</h6>
          <AddAccess moduleName="Activities">
            <a
              onClick={() => {
                setResourceModal((pre) => ({
                  ...pre,
                  open: true,
                  title: "Add New Resource",
                }));
              }}
              className="primary"
              style={{
                fontSize: 16,
                cursor: "pointer",
              }}
            >
              <PlusSquareOutlined /> Add Resource
            </a>
          </AddAccess>
        </div>
        <Alert
          isOpen={!!allocatedResourcesError}
          color="danger"
          className="start-0 w-100 py-1 mt-2"
          style={{
            top: 0,
            textAlign: "left",
            fontSize: "14px",
            cursor: "default",
          }}
        >
          <Icon name={"info"} style={{ top: "0.6rem" }} />
          <ReactTyped
            strings={[allocatedResourcesError || ""]}
            typeSpeed={10}
            showCursor={false}
          />
        </Alert>
        <div
          style={
            embedded
              ? { width: "100%" }
              : { width: screenSize - 120 + "px", margin: "10px auto" }
          }
        >
          <Table
            rowKey={nanoid()}
            columns={resourceColumns}
            dataSource={fields}
            pagination={false}
            bordered
            size="middle"
            scroll={{
              x: 1260,
            }}
            locale={{
              emptyText: (
                <>
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={
                      <>
                        <strong>
                          No Resource Found, Please{" "}
                          <AddAccess moduleName="Activities">
                            <a
                              onClick={() => {
                                setResourceModal((pre) => ({
                                  ...pre,
                                  open: true,
                                  title: "Add New Resource",
                                }));
                              }}
                              className="primary"
                              style={{
                                fontSize: 16,
                                cursor: "pointer",
                              }}
                            >
                              Add Resource.
                            </a>
                          </AddAccess>
                        </strong>
                      </>
                    }
                  />
                </>
              ),
            }}
          />
        </div>
        <br />

      </>
    );
  };

  const archiveActivity = async (activityId: number) => {
    try {
      const response = await activityApis.archiveActivity(activityId);
      const { data, status: apiStatus } = response || {};
      if (apiStatus) {
        const { id, message } = data || {};
        Swal.fire({
          title: "Success",
          text: message,
          icon: "success",
          confirmButtonText: "OK",
        });
        fetchDataById(activityId);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const deleteActivity = async (activityId: number) => {
    try {
      const response = await activityApis.deleteActivity(activityId);
      const { data, status: apiStatus } = response || {};
      if (apiStatus) {
        const { id, message } = data || {};
        Swal.fire({
          title: "Success",
          text: message,
          icon: "success",
          confirmButtonText: "OK",
        });
        fetchDataById(activityId);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchDataById = async (id: any, mode?: "edit" | "view") => {
    try {
      const response: any = await activityApis.fetchActivityById(
        id,
        screenName
      );
      const {
        data,
        status,
      }: {
        status: boolean;
        statusCode: 200;
        message: string;
        data: {
          activityId: number;
          orgId: number;
          activityName: string;
          phaseId: number;
          projectId: number;
          activityOwnerId: number;
          activityBudgetLineId: number;
          flag: ActivityFlagEnum;
          status: string;
          tasksCompletionPercentage: string;
          totalTasks: number;
          completedTasks: number;
          createdAt: string;
          activityOwnerName: string;
          activityBudgetLineName: string;
          activityStartDate: string;
          activityEndDate: string;
          activityWeightage: string;
          activityBoqs: {
            activityBoqId: number;
            activityId: number;
            orgId: number;
            siteId: number;
            boqTargetId: number;
            materialId: number;
            categoryId: number;
            allotedQuantity: string;
            status: string;
            materialName: string;
            categoryName: string;
            uomName: string;
            boqLineName?: string;
            siteStructureUnitName?: string;
            floorNo?: string;
            siteStructureSubUnitName?: string;
            locationName?: string;
            boqTitle?: string;
            boqTargetNumber?: string;
            quantity?: number;
          }[];
          activityResources: {
            activityResourceId: number;
            activityId: number;
            phaseId: number;
            projectId: number;
            orgId: number;
            laborTypeId: number;
            resourceType: string;
            laborName: string;
            laborRole: string;
            phoneNumber: string;
            status: string;
            laborTypeName: string;
            userName: string;
          }[];
          activityTags: ActivityTagsInterface[];
          phaseName: string;
          projectTitle: string;
          originalActivityOwnerName?: string;
          originalActivityOwnerId?: number;
          reassignedReason?: string;
          hierarchyUserIds?: number[];
        };
      } = response || {};
      if (status) {
        setMode(mode || "view");
        setOriginalData(data);

        const {
          activityId,
          activityName,
          phaseId,
          projectId,
          activityOwnerId,
          activityBudgetLineId,
          flag,
          activityStartDate,
          activityEndDate,
          // activityWeightage,
          // status,
          // tasksCompletionPercentage,
          // totalTasks,
          // completedTasks,
          // createdAt,
          activityOwnerName,
          activityBudgetLineName,
          activityBoqs,
          activityResources,
          activityTags,
          activityWeightage,
          originalActivityOwnerName,
          originalActivityOwnerId,
          reassignedReason,
          phaseName,
          projectTitle,
          status,
        } = data;
        setActiveBoqs(
          activityBoqs?.map((boq: any) => {
            const {
              boqTargetId,
              materialId,
              categoryId,
              uomId,
              boqLineId,
              boqTargetLineId,
              targetLineId,
              targetId,
            } = boq;
            // Must mirror the key built in the boqLinesDataSource useEffect,
            // which uses targetLineId || targetId for the 2nd segment.
            const lineKeyPart =
              boqTargetLineId ?? targetLineId ?? targetId ?? boqTargetId;
            return {
              ...boq,
              key:
                boqTargetId +
                "~~" +
                lineKeyPart +
                "~~" +
                categoryId +
                "~~" +
                materialId +
                "~~" +
                uomId +
                (boqLineId ? "~~" + boqLineId : ""),
              activityBoqId: boq?.activityBoqId,
              boqTargetId: boqTargetId,
              boqTargetNumber: boq?.boqTargetNumber || "N/A",
              boqTitle: boq?.boqTitle || "N/A",
              categoryId: categoryId,
              categoryName: boq?.categoryName || "N/A",
              materialId: materialId,
              materialName: boq?.materialName || "N/A",
              quantity: boq?.quantity,
              allocateBOQQuantity: boq?.allotedQuantity,
              allotedQuantity: boq?.allotedQuantity,
              uomId: uomId,
              uomName: boq?.uomName || "N/A",
            };
          })
        );
        const formattedActiveResources: any = [];
        activityResources?.forEach((resource: any) => {
          formattedActiveResources?.push({
            activityResourceId: resource?.activityResourceId,
            laborTypeId: +resource?.laborTypeId,
            labourTypeName: resource?.laborTypeName,
            laborCategoryId: +resource?.laborCategoryId,
            laborCategory: resource?.laborCategoryName,
          });
        });

        const uniqueBoqLineIds = activityBoqs?.reduce((acc: any, boq: any) => {
          if (!acc?.includes(boq.boqTargetId)) {
            acc?.push(boq.boqTargetId);
          }
          return acc;
        }, []);
        const tagIdActivityTagIdMap: any = {};
        const _tagOptions = activityTags?.map((tag: ActivityTagsInterface) => {
          tagIdActivityTagIdMap[tag.tagId] = tag.activityTagId;
          return {
            label: tag.tagName,
            value: tag?.tagId,
          };
        });
        setTags(_tagOptions);
        setOriginalTagIdActivityTagId(tagIdActivityTagIdMap);

        const resetValues: any = {
          activityId: activityId,
          activityName: activityName,
          projectId: projectId,
          activityOwnerId: activityOwnerId,
          activityOwnerName: activityOwnerName,
          activityBudgetLineId: activityBudgetLineId,
          activityBudgetLineName: activityBudgetLineName,
          flag: flag,
          boqLineIds: uniqueBoqLineIds,
          allocatedResources: formattedActiveResources,
          activityWeightage: +activityWeightage,
        };
        if (activityStartDate)
          resetValues.activityStartDate = dayjs(activityStartDate);
        if (activityEndDate)
          resetValues.activityEndDate = dayjs(activityEndDate);
        reset(resetValues);

        // Initialize budget line info if activity has budget line
        if (activityBudgetLineId && budgetLines.length > 0) {
          const selectedBudget = budgetLines.find(
            (budget) => budget.value === activityBudgetLineId
          );
          if (selectedBudget?.extra) {
            setSelectedBudgetValue(selectedBudget.extra.budgetValue);
            setSelectedBudgetLine({
              lineId: selectedBudget.value as number,
              headerId: 0,
              budgetId: selectedBudget.extra.budgetId,
              budgetLineName: selectedBudget.extra.budgetLineName,
              budgetValue: selectedBudget.extra.budgetValue,
              allocatedLineValue: selectedBudget.extra.allocatedLineValue,
            });
          }
        }

        // Check if current user is admin
        const isAdmin = currentUser?.genericRole?.toLowerCase() === "admin";

        // Recalculate base conditions from response data (prefer response, fallback to Redux store)
        const responseProjectStatus = (data as any)?.projectStatus;
        const responsePhaseStatus = (data as any)?.phaseStatus;
        const currentProjectStatus =
          responseProjectStatus || projectStatus || "";
        const currentPhaseStatus = responsePhaseStatus || phaseStatus || "";

        // Check base conditions for status change
        const statusChangeBaseConditions =
          [
            "draft",
            "active",
            "inprogress",
            "onhold",
            "cancelled",
            "archived",
            "closed",
          ].includes(status?.toLowerCase()) &&
          !["onhold", "cancelled", "archived", "closed"].includes(
            currentProjectStatus?.toLowerCase()
          ) &&
          !["onhold", "cancelled", "archived", "closed"].includes(
            currentPhaseStatus?.toLowerCase()
          ) &&
          (lock === false || lockedBy == currentUser?.id);

        // Check if user is in hierarchyUserIds - filter out duplicates and invalid values
        const isInHierarchy =
          data?.hierarchyUserIds &&
          Array.isArray(data.hierarchyUserIds) &&
          currentUser?.id &&
          data.hierarchyUserIds
            .filter((id: number) => id > 0) // Filter out 0 and negative values
            .includes(currentUser?.id);

        // Check module-level edit permission
        const hasModulePermission = hasModuleEditPermission("Activities");

        // RESTRICTIVE: Show status dropdown based on:
        // - Owner: Module permission AND owner check
        // - Admin: Module permission only (hierarchy not needed)
        // - Others: Module permission AND hierarchy (both required)
        const canOwnerChangeStatus =
          currentUser?.id === activityOwnerId &&
          hasModulePermission &&
          statusChangeBaseConditions;
        const canAdminChangeStatus =
          isAdmin && hasModulePermission && statusChangeBaseConditions;
        const canOthersChangeStatus =
          hasModulePermission && isInHierarchy && statusChangeBaseConditions;

        if (
          canOwnerChangeStatus ||
          canAdminChangeStatus ||
          canOthersChangeStatus
        ) {
          setShowStatusDropDown(true);
        }

        // RESTRICTIVE ACCESS: Start with false, grant only to owner, hierarchy users, admin, or users with module permission
        let _allowEdit = false;

        // Check base conditions first (using already calculated currentProjectStatus and currentPhaseStatus from above)
        const baseConditionsMet =
          !["onhold", "cancelled", "archived", "closed"].includes(
            status?.toLowerCase()
          ) &&
          !["onhold", "cancelled", "archived", "closed"].includes(
            currentProjectStatus?.toLowerCase()
          ) &&
          !["onhold", "cancelled", "archived", "closed"].includes(
            currentPhaseStatus?.toLowerCase()
          ) &&
          (lock === false || lockedBy == currentUser?.id);

        // Grant edit access based on:
        // - Owner: Module permission AND owner check
        // - Admin: Module permission only (hierarchy not needed)
        // - Others: Module permission AND hierarchy (both required)
        if (baseConditionsMet) {
          // Owner: Module permission AND owner check
          if (currentUser?.id === activityOwnerId && hasModulePermission) {
            _allowEdit = true;
          }
          // Admin: Module permission only
          else if (isAdmin && hasModulePermission) {
            _allowEdit = true;
          }
          // Others: Module permission AND hierarchy (both required)
          else if (
            hasModulePermission &&
            data?.hierarchyUserIds &&
            Array.isArray(data.hierarchyUserIds) &&
            currentUser?.id
          ) {
            const validHierarchyUserIds = data.hierarchyUserIds.filter(
              (id: number) => id > 0
            );
            if (validHierarchyUserIds.includes(currentUser?.id)) {
              _allowEdit = true;
            }
          }
        }
        // Separate permission for Add Task - less restrictive (anyone with module permission can add if conditions are met)
        let _allowAdd = false;
        if (
          !["onhold", "cancelled", "archived", "closed", "deleted"].includes(
            status?.toLowerCase()
          ) &&
          !["onhold", "cancelled", "archived", "closed"].includes(
            projectStatus?.toLowerCase()
          ) &&
          !["onhold", "cancelled", "archived", "closed"].includes(
            phaseStatus?.toLowerCase()
          ) &&
          (lock === false || lockedBy == currentUser?.id)
        ) {
          _allowAdd = true;
        }

        const modalData: any = {
          activityName: activityName,
          extra: {
            status: status,
            createdAt: data?.createdAt,
            createdByUserName: "",
            startDate: data?.activityStartDate,
            endDate: data?.activityEndDate,
            ownerName: data?.activityOwnerName,
            ownerId: data?.activityOwnerId,
            originalActivityOwnerName,
            originalActivityOwnerId,
            reassignedReason,
          },
        };
        modalData.allowEdit = _allowEdit;
        modalData.allowAdd = _allowAdd;
        dispatch(updateActivityInDetailModalSlice(modalData));
      } else {
        console.log(response);
      }
    } catch (error) {
      console.log("Error loading data:", error);
    } finally {
      setLoading(false);
    }
  };

  const saveChanges = async (data: any) => {
    setLoading(true);
    try {
      let materialAllocationOriginalData: any = {};
      originalData?.activityBoqs?.forEach((boq: any) => {
        const {
          boqTargetId,
          materialId,
          categoryId,
          uomId,
          allotedQuantity,
          activityBoqId,
          boqLineId,
          boqTargetLineId,
          targetLineId,
          targetId,
        } = boq;
        // Must mirror the key built in the boqLinesDataSource useEffect.
        const lineKeyPart =
          boqTargetLineId ?? targetLineId ?? targetId ?? boqTargetId;
        materialAllocationOriginalData[
          boqTargetId +
          "~~" +
          lineKeyPart +
          "~~" +
          categoryId +
          "~~" +
          materialId +
          "~~" +
          uomId +
          (boqLineId ? "~~" + boqLineId : "")
        ] = {
          allotedQuantity: +allotedQuantity,
          activityBoqId: +activityBoqId,
        };
      });
      // const {
      //   status: materialAllocationStatus,
      //   message: materialAllocationMessage,
      // } = validateAllocateMaterials();
      // if (!materialAllocationStatus) {
      //   materialAllocateErrorsRef?.current?.scrollIntoView({
      //     behavior: "smooth",
      //   });
      //   setBoqMaterialsError(materialAllocationMessage);
      //   return;
      // }

      const values = await form.validateFields();
      const { errorFields } = values;
      if (errorFields) {
        return;
      }
      const _newMaterialAllocation: any = [];
      const _updatedMaterialAllocation: any = [];
      Object.keys(values)?.forEach((_key) => {
        const key = _key?.split("_")[1];
        const keyParts = key.split("~~");
        const [
          boqTargetId,
          targetId,
          categoryId,
          materialId,
          uomId,
          boqLineId,
        ] = keyParts;

        if (materialAllocationOriginalData[key]?.activityBoqId) {
          if (
            +values[_key] !=
            +materialAllocationOriginalData[key]?.allotedQuantity
          ) {
            _updatedMaterialAllocation.push({
              activityBoqId:
                +materialAllocationOriginalData[key]?.activityBoqId,
              allotedQuantity: +values[_key],
            });
          }
          delete materialAllocationOriginalData[key];
        } else {
          // Find the targetLineId and boqLineId from the boqLinesDataSource.
          // boqTargetLineId must come from the master line — never fall back
          // to keyParts[1] because, when targetLineId is missing on the master,
          // that slot holds targetId (a BOQ target ID), which the backend
          // would otherwise receive in place of a line ID.
          const lineData = boqLinesDataSource.find(
            (line: any) => line.key === key
          );
          _newMaterialAllocation.push({
            boqTargetId: +boqTargetId,
            boqTargetLineId: lineData?.targetLineId,
            boqLineId: lineData?.boqLineId || boqLineId || undefined,
            materialId: +materialId,
            categoryId: +categoryId,
            targetId: +targetId,
            uomId: +uomId,
            allotedQuantity: values[_key],
          });
        }
      });
      const _deletedMaterialAllocation = Object.keys(
        materialAllocationOriginalData
      )?.map((key) => {
        return {
          activityBoqId: +materialAllocationOriginalData[key]?.activityBoqId,
        };
      });

      const _updatedResources: any = { ...updatedResources };
      const _deletedResources: any = [...deletedResources];
      const _newResources = data?.allocatedResources?.filter(
        (r: any) => !r?.activityResourceId
      );
      let dirtyData = getDirtyFieldsOnly(data, dirtyFields) || {};

      if (tags || deselectedTags) {
        const newLines =
          tags
            ?.filter((t: any) => typeof t?.value === "string")
            ?.map((newTag: any) => ({
              tagName: newTag?.label,
              activityTagId: newTag?.value,
            })) || [];

        const deletedLines =
          deselectedTags?.map((t: any) => ({
            activityTagId: originalTagIdActivityTagId[t],
          })) || [];

        if (newLines.length > 0 || deletedLines.length > 0) {
          dirtyData.activityTags = {
            ...(newLines.length > 0 && { newLines }),
            ...(deletedLines.length > 0 && { deletedLines }),
          };
        }
      }

      if (
        _newResources?.length > 0 ||
        _deletedResources?.length > 0 ||
        Object.keys(_updatedResources)?.length > 0
      ) {
        dirtyData.activityResources = {
          ...(_newResources?.length > 0 && {
            newLines: _newResources?.map((r: any) => ({
              laborTypeId: r?.laborTypeId,
              laborCategoryId: r?.laborCategoryId,
            })),
          }),
          ...(_deletedResources?.length > 0 && {
            deletedLines: _deletedResources?.map((id: any) => ({
              activityResourceId: id,
            })),
          }),
          ...(Object.keys(_updatedResources)?.length > 0 && {
            updatedLines: Object.keys(_updatedResources).map((id: any) => ({
              activityResourceId: id,
              laborTypeId: _updatedResources[id]?.laborTypeId,
              laborCategoryId: _updatedResources[id]?.laborCategoryId,
            })),
          }),
        };
      }

      // BOQ / materials allocation is delinked — materials now come from norms
      // (Apply Norm). activityBoqs is never sent on save, so existing
      // activity_boqs rows are left untouched (no accidental deletedLines wipe).


      if (dirtyData.activityStartDate) {
        dirtyData.activityStartDate = dayjs(
          dirtyData.activityStartDate
        )?.format("YYYY-MM-DD");
      }
      if (dirtyData.activityEndDate) {
        dirtyData.activityEndDate = dayjs(dirtyData.activityEndDate)?.format(
          "YYYY-MM-DD"
        );
      }

      delete dirtyData?.allocatedResources;
      if (dirtyData === undefined || Object.keys(dirtyData).length === 0) {
        setMode("view");
        setLoading(false);
        return;
      }
      const payload: {
        activityId: number;
        projectId: number;
        phaseId: number;
        activityName: string;
        activityOwnerId: number;
        activityBudgetLineId: number;
        activityStartDate: string;
        activityEndDate: string;
        flag: ActivityFlagEnum;
        activityTags: {
          newLines: {
            tagName: string;
          }[];
          deletedLines: {
            activityTagId: number;
          }[];
        };
        activityBoqs: {
          newLines: {
            boqTargetId: number;
            boqTargetLineId: number;
            materialId: number;
            categoryId: number;
            allotedQuantity: number;
            resourceType: "Labour" | "User";
          }[];
          updatedLines: {
            activityBoqId: number;
            allotedQuantity: number;
            resourceType: "Labour" | "User";
          }[];
          deletedLines: {
            activityBoqId: number;
          }[];
        };
        activityResources: {
          newLines: {
            laborTypeId: number;
            laborName: string;
            laborRole: string;
            phoneNumber: string;
            userId: number;
          }[];
          updatedLines: {
            activityResourceId: number;
            laborTypeId: number;
            laborName: string;
            laborRole: string;
            phoneNumber: string;
          }[];
          deletedLines: {
            activityResourceId: number;
          }[];
        };
      } = {
        activityId: +activityId,
        projectId: +(projectId ?? 0),
        phaseId: +(phaseId ?? 0),
        ...dirtyData,
      };
      // Only show owner change modal if owner is actually being changed
      if (
        payload?.activityOwnerId &&
        payload?.activityOwnerId !== originalData?.activityOwnerId
      ) {
        setLoading(false);
        setOwnerChangeModalOpen({
          open: true,
          extraData: payload,
        });
      } else updateActivity(payload);
    } catch (error) {
      console.log(error);
    }
  };

  const handleStatusChange = ({ key }: { key: string }) => {
    if (key?.toLocaleLowerCase() == "onhold") {
      setStatusChangeModalOpen({
        open: true,
        extraData: key,
      });
    } else updateActivityStatus(key);
  };
  const updateActivityStatus = async (
    status: string,
    activityOnHoldReason?: string,
    activityETAResolution?: string
  ) => {
    try {
      const response = await activityApis.statusChangeActivity(
        activityId,
        status,
        activityOnHoldReason,
        activityETAResolution
      );
      const { data, status: apiStatus, message } = response || {};
      if (apiStatus) {
        Swal.fire({
          title: "Success",
          text: `Activity status updated to ${status} successfully`,
          icon: "success",
          confirmButtonText: "OK",
        });
        fetchDataById(phaseId, "view");
      } else {
        Swal.fire({
          title: "Error",
          text: message,
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const updateActivity = async (Payload: any) => {
    try {
      const response: ApiResponse = await activityApis.updateActivity(
        CustomJsonParse(Payload, 0, 5)
      );
      const { data, status, message, error } = response || {};
      if (status) {
        Swal.fire({
          icon: "success",
          title: "Updated Successfully",
          text: data?.message,
          confirmButtonText: "Ok",
        });
        setMode("view");
        setUpdatedResources({});
        setDeletedResources([]);
        fetchDataById(activityId);
        // Notify parent to refresh list
        if (onRefresh) {
          onRefresh();
        }
      } else {
        setErrorData({ error, message });
        setTimeout(() => {
          setErrorData(undefined);
        }, 10000);
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchActivityWeightages = async () => {
    try {
      const response: any = await activityApis.getPhaseActivityWeightage(
        Number(projectId),
        phaseId ? Number(phaseId) : undefined
      );
      const {
        data: list,
        status,
      }: {
        status: boolean;
        data: { activityId: number; activityWeightage: number }[];
      } = response || {};
      if (status) {
        // Exclude current activity so its existing weightage stays available
        const total = (list || [])
          .filter(
            (item) => Number(item?.activityId) !== Number(activityId)
          )
          .reduce(
            (sum, item) => sum + (Number(item?.activityWeightage) || 0),
            0
          );
        setRemainingWeightage(Math.max(0, 100 - total));
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (mode !== "view") {
      onSelectChange(
        activeBoqs?.map((boq: any) => boq?.key),
        activeBoqs
      );
      fetchLabourTypesList();
      fetchLaborCategoriesList();
      fetchProjectUsers();
      fetchProjectTags();
      fetchProjectBoqs();
      fetchBudgetLines();
      if (projectId && activityId) {
        fetchActivityWeightages();
      }
    } else {
      setRemainingWeightage(null);
    }
  }, [mode, projectId, phaseId, activityId]);

  // Populate Tags dropdown options when projectTagsList loads
  useEffect(() => {
    if (projectTagsList?.length > 0) {
      fetchTagSuggestions("");
    }
  }, [projectTagsList]);

  useEffect(() => {
    // For embedded mode, use propActivityId directly
    // For modal mode, require both activityId and activityOpen
    if (embedded && propActivityId) {
      fetchStatusFilterData();
      fetchDataById(propActivityId, initialMode);
    } else if (activityId && activityOpen) {
      fetchStatusFilterData();
      fetchDataById(activityId);
    }
  }, [activityId, activityOpen, propActivityId, embedded]);

  // Notify parent of mode changes
  useEffect(() => {
    if (onModeChange) {
      onModeChange(mode);
    }
  }, [mode]);

  useEffect(() => {
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
    };
  }, []);

  if (loading) {
    return (
      <Flex align="center" gap="middle" className="pageLoader">
        <Spin
          indicator={<LoadingOutlined spin />}
          className="m-auto"
          size="large"
        />
      </Flex>
    );
  }

  return (
    <>
      <OwnerChangeReason
        open={ownerChangeModalOpen?.open}
        setOpen={(open: boolean) => {
          setOwnerChangeModalOpen({
            open: open,
            extraData: { ...ownerChangeModalOpen?.extraData },
          });
        }}
        onSubmit={(data: any) => {
          setLoading(true);
          updateActivity({
            ...ownerChangeModalOpen?.extraData,
            reassignedReason: data,
          });
        }}
      />
      <StatusChangeReason
        open={statusChangeModalOpen?.open}
        setOpen={(open: boolean) => {
          setStatusChangeModalOpen({
            open: open,
            extraData: "",
          });
        }}
        onSubmit={(data: any, ETA: any) => {
          updateActivityStatus(statusChangeModalOpen?.extraData, data, ETA);
        }}
      />
      <div className={`mt-2 ${embedded ? "activity-fields-embedded" : ""}`} style={embedded ? { width: "100%", maxWidth: "100%", minWidth: 0 } : undefined}>
        <div className="d-flex justify-content-between align-items-center mb-2 ">
          <h5 className="title mt-2">Activity Information</h5>
          <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2 pe-2">
            {mode == "edit" ? (
              <>
                <li>
                  <Button
                    className="btn btn-primary btn-sm"
                    type="button"
                    color="primary"
                    onClick={handleSubmit(saveChanges)}
                  >
                    <Icon name={"save"} />
                    <span>Save</span>
                  </Button>
                </li>
                <li>
                  <Button
                    className="btn btn-secondary btn-sm"
                    type="button"
                    color="secondary"
                    onClick={() => {
                      setLoading(true);
                      fetchDataById(activityId);
                      setMode("view");
                      // resettingFields(originalData);
                    }}
                  >
                    <span>Cancel</span>
                  </Button>
                </li>
              </>
            ) : (
              <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2 pe-2 ms-auto">
                <li>
                  <Breadcrumb className="">
                    <Breadcrumb.Item>
                      <span style={{ fontWeight: 500 }}>CURRENT STATUS</span>{" "}
                      :&nbsp;
                      <Text
                        style={{
                          color: "#2557d6",
                          fontWeight: 500,
                        }}
                      >
                        {getLabel(statusFilterData, originalData?.status)}
                      </Text>
                      {!embedded && showStatusDropDown && (
                        <EditAccess moduleName="Activities">
                          <Dropdown
                            menu={{
                              items: statusFilterData.map((item) => ({
                                key: item.value,
                                label: item.label,
                              })),
                              selectedKeys: [originalData?.status],
                              onClick: handleStatusChange,
                            }}
                            disabled={!showStatusDropDown}
                          >
                            <a onClick={(e) => e.preventDefault()}>
                              <Space>
                                <DownOutlined style={{ color: "#2557d6" }} />
                              </Space>
                            </a>
                          </Dropdown>
                        </EditAccess>
                      )}
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </li>
                {/* Show three dots menu if user has any permissions (hidden in embedded mode) */}
                {!embedded && (allowEdit || canCancel("Activities")) ? (
                  <li>
                    <UncontrolledDropdown>
                      <DropdownToggle
                        tag="a"
                        className="dropdown-toggle btn btn-icon btn-trigger"
                      >
                        <Icon name="more-v"></Icon>
                      </DropdownToggle>
                      <DropdownMenu end>
                        <ul className="link-list-opt">
                          <EditAccess moduleName="Activities">
                            {allowEdit && (
                              <li>
                                <DropdownItem
                                  tag="a"
                                  href="#tableView"
                                  onClick={(ev: any) => {
                                    ev.preventDefault();
                                    setMode("edit");
                                  }}
                                >
                                  <span>Edit </span>
                                </DropdownItem>
                              </li>
                            )}
                          </EditAccess>

                          {!["Archived"]?.includes(originalData?.status) ? (
                            // <CancelAccess moduleName="Activities">
                            <li>
                              <DropdownItem
                                tag="a"
                                href="#detailView"
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "You won't be able to revert this!",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes, archive it!",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      archiveActivity(activityId as number);
                                    }
                                  });
                                }}
                              >
                                <span>Archive</span>
                              </DropdownItem>
                            </li>
                          ) : (
                            // </CancelAccess>
                            <></>
                          )}

                          <CancelAccess moduleName="Activities">
                            <li>
                              <DropdownItem
                                tag="a"
                                href="#detailView"
                                onClick={(ev) => {
                                  ev.preventDefault();
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "You won't be able to revert this!",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes, delete it!",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      deleteActivity(activityId as number);
                                    }
                                  });
                                }}
                              >
                                <span>Delete</span>
                              </DropdownItem>
                            </li>
                          </CancelAccess>
                        </ul>
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  </li>
                ) : (
                  <></>
                )}
              </ul>
            )}
          </ul>
        </div>
        <Alert
          isOpen={
            !!(
              lock &&
              !allowEdit &&
              originalData?.status?.toLowerCase() !== "onhold"
            )
          }
          color="warning"
          className="start-0 w-100 py-1 mt-2"
          style={{
            top: 0,
            textAlign: "left",
            fontSize: "14px",
            cursor: "default",
          }}
        >
          <span className="fw-bold">Locked:</span>{" "}
          <ReactTyped
            strings={[
              `This Project is currently Locked. Last Locked on ${lockedOn} by "${lockedByUserName}".`,
            ]}
            typeSpeed={5}
            showCursor={false}
          />
        </Alert>
        {contextHolder}
        <Alert
          isOpen={originalData?.status?.toLowerCase() === "onhold"}
          color="warning"
          className="start-0 w-100 py-1 mt-2"
          style={{
            top: 0,
            textAlign: "left",
            fontSize: "14px",
            cursor: "default",
          }}
        >
          Activity is On-Hold on{" "}
          <span className="fw-bold">
            {dayjs(originalData?.activityOnholdDate)?.format("DD-MMM-YYYY")}
          </span>{" "}
          till{" "}
          <span className="fw-bold">
            {dayjs(originalData?.activityETAResolution)?.format("DD-MMM-YYYY")}
          </span>
          .{" "}
          <ReactTyped
            strings={[
              "Because of, " + (originalData?.activityOnholdReason || ""),
            ]}
            typeSpeed={10}
            showCursor={false}
          />
        </Alert>
        <Alert
          isOpen={errorData != undefined}
          color="danger"
          className="start-0 w-100 py-1 mt-2"
          style={{
            top: 0,
            textAlign: "left",
            fontSize: "14px",
            cursor: "default",
          }}
        >
          <span className="fw-bold">{errorData?.error}: </span>
          <ReactTyped
            strings={[errorData?.message || ""]}
            typeSpeed={10}
            showCursor={false}
          />
        </Alert>
        <FormProvider {...methods}>
          <form className="content clearfix mt-2">
            <div className="row g-3">
              <div className="col-4">
                <FormInput
                  name="activityName"
                  label={undefined}
                  optionLabel="Activity Name"
                  optionLabelWidth={"130px"}
                  disabled
                  unMaskView={true}
                />
              </div>
              <div className="col-4">
                {mode == "view" ? (
                  <FormInput
                    name="activityOwnerName"
                    label={undefined}
                    optionLabel={
                      <span>
                        Owner{" "}
                        {originalActivityOwnerId &&
                          originalActivityOwnerId != ownerId ? (
                          <Popconfirm
                            title={<></>}
                            icon={<></>}
                            showCancel={false}
                            trigger="hover"
                            okButtonProps={{
                              style: {
                                display: "none",
                              },
                            }}
                            description={
                              <Descriptions
                                title=""
                                bordered
                                column={1}
                                size="small"
                                className="custom-description-title"
                              >
                                <Descriptions.Item label="Original Owner">
                                  {originalActivityOwnerName || "N/A"}
                                </Descriptions.Item>
                                <Descriptions.Item label="Reason">
                                  {reassignedReason || "N/A"}
                                </Descriptions.Item>
                              </Descriptions>
                            }
                          >
                            <Icon
                              name="info"
                              style={{
                                cursor: "pointer",
                                fontSize: "13px",
                              }}
                            />
                          </Popconfirm>
                        ) : (
                          <></>
                        )}
                      </span>
                    }
                    optionLabelWidth={"130px"}
                    disabled
                    unMaskView={mode === "view"}
                  />
                ) : (
                  <FormSelect
                    name="activityOwnerId"
                    label={undefined}
                    optionLabel="Owner"
                    optionLabelWidth={"130px"}
                    placeholder="Select Owner"
                    options={projectUsers}
                  // disabled={mode === "view"}
                  />
                )}
              </div>
              <div className="col-4">
                <FormSelect
                  name="flag"
                  label={undefined}
                  optionLabel="Flag"
                  optionLabelWidth={"130px"}
                  placeholder="Select Flag"
                  options={[
                    { label: "Internal", value: "Internal" },
                    { label: "External", value: "External" },
                  ]}
                  disabled={mode == "view"}
                  unMaskView={mode === "view"}
                  customStyle={
                    mode === "view"
                      ? {
                        color: "#526484",
                        backgroundColor: "transparent",
                        border: "none",
                        boxShadow: "none",
                      }
                      : {}
                  }
                />
              </div>
            </div>
            <div className="row g-3">
              <div className="col-4">
                {mode === "view" ? (
                  <div className="form-group mb-1">
                    <div className="form-control-wrap">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <label
                          className="form-label"
                          style={{
                            width: "130px",
                            margin: 0,
                            fontSize: "0.875rem",
                            fontWeight: 500,
                            marginRight: "24px",
                          }}
                        >
                          Planned Start Date
                        </label>
                        <span
                          style={{ fontSize: "0.875rem", color: "#526484" }}
                        >
                          {watch("activityStartDate")
                            ? dayjs(watch("activityStartDate")).format(
                              "DD-MMM-YYYY"
                            )
                            : "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <FormDatePicker
                    name="activityStartDate"
                    label={undefined}
                    optionLabelWidth={"130px"}
                    optionLabel="Planned Start Date"
                    disabled={false}
                    placeholder="Select Start Date"
                  />
                )}
              </div>
              <div className="col-4">
                {mode === "view" ? (
                  <div className="form-group mb-1">
                    <div className="form-control-wrap">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <label
                          className="form-label"
                          style={{
                            width: "130px",
                            margin: 0,
                            fontSize: "0.875rem",
                            fontWeight: 500,
                            marginRight: "24px",
                          }}
                        >
                          Planned End Date
                        </label>
                        <span
                          style={{ fontSize: "0.875rem", color: "#526484" }}
                        >
                          {watch("activityEndDate")
                            ? dayjs(watch("activityEndDate")).format(
                              "DD-MMM-YYYY"
                            )
                            : "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <FormDatePicker
                    name="activityEndDate"
                    optionLabel="Planned End Date"
                    label={undefined}
                    optionLabelWidth={"130px"}
                    minDate={startDateWatch}
                    disabled={false}
                    placeholder="Select End Date"
                  />
                )}
              </div>
              <div className="col-4">
                {mode == "view" ? (
                  <FormInput
                    name="activityBudgetLineName"
                    optionLabel="Budget Line"
                    placeholder="N/A"
                    label={undefined}
                    optionLabelWidth={"130px"}
                    disabled
                    unMaskView={mode === "view"}
                  />
                ) : (
                  <FormSelect
                    name="activityBudgetLineId"
                    optionLabel={
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "4px",
                        }}
                      >
                        <span>Budget Line</span>
                        <span style={{ color: "red" }}>*</span>
                        {selectedBudgetLine && (
                          <Popconfirm
                            placement="right"
                            title={<></>}
                            icon={<></>}
                            showCancel={false}
                            trigger="hover"
                            okButtonProps={{
                              style: {
                                display: "none",
                              },
                            }}
                            description={
                              <div className="d-flex flex-column">
                                <Descriptions
                                  title=""
                                  bordered
                                  column={1}
                                  size="small"
                                  className="custom-description-title"
                                >
                                  <Descriptions.Item label="Budget Value">
                                    ₹
                                    {selectedBudgetLine.budgetValue?.toLocaleString(
                                      "en-IN"
                                    )}
                                  </Descriptions.Item>
                                  <Descriptions.Item label="Allocated Value">
                                    ₹
                                    {selectedBudgetLine.allocatedLineValue?.toLocaleString(
                                      "en-IN"
                                    )}
                                  </Descriptions.Item>
                                  <Descriptions.Item label="Remaining">
                                    ₹
                                    {(
                                      selectedBudgetLine.budgetValue -
                                      selectedBudgetLine.allocatedLineValue
                                    )?.toLocaleString("en-IN")}
                                  </Descriptions.Item>
                                </Descriptions>
                              </div>
                            }
                          >
                            <Icon
                              name="info"
                              className="ms-1"
                              style={{
                                color: "#1890ff",
                                cursor: "pointer",
                                fontSize: "16px",
                              }}
                            />
                          </Popconfirm>
                        )}
                      </div>
                    }
                    placeholder="Select Budget Line"
                    options={budgetLines}
                    optionLabelWidth={"130px"}
                    label={undefined}
                    required={true}
                  />
                )}
              </div>
            </div>
            <div className="mt-2"></div>
            <div className="row g-3">
              <div className="col-4">
                {mode === "view" ? (
                  <div className="form-group mb-1">
                    <div className="form-control-wrap">
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <label
                          className="form-label"
                          style={{
                            width: "130px",
                            margin: 0,
                            fontSize: "0.875rem",
                            fontWeight: 500,
                            marginRight: "24px",
                          }}
                        >
                          Weightage
                        </label>
                        <span
                          style={{ fontSize: "0.875rem", color: "#526484" }}
                        >
                          {watch("activityWeightage")
                            ? `${watch("activityWeightage")}%`
                            : "N/A"}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  <FormInput
                    name="activityWeightage"
                    optionLabel={
                      <span>
                        Weightage
                        {remainingWeightage !== null && (
                          <span
                            style={{
                              color: "#52c41a",
                              marginLeft: "8px",
                              fontWeight: "normal",
                            }}
                          >
                            (Avl: {remainingWeightage}%)
                          </span>
                        )}
                      </span>
                    }
                    placeholder="Enter Weightage"
                    type="number"
                    pattern={/^(?:100|[1-9][0-9]?)$/}
                    patternErrorMessage="Enter a value between 1 to 100"
                    disabled={false}
                    label={undefined}
                    optionLabelWidth={"130px"}
                    customValidation={{
                      validate: (value: string) => {
                        if (
                          remainingWeightage === null ||
                          value === undefined ||
                          value === null ||
                          value === ""
                        )
                          return true;
                        const n = Number(value);
                        if (Number.isNaN(n)) return true;
                        return (
                          n <= remainingWeightage ||
                          `Cannot exceed available (${remainingWeightage}%)`
                        );
                      },
                    }}
                  />
                )}
              </div>
              <div className="col-8">
                <div className="form-group">
                  <div className="form-control-wrap">
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <label
                        className="form-label"
                        style={{
                          width: "130px",
                          margin: 0,
                          fontSize: "0.875rem",
                          fontWeight: 500,
                          marginRight: mode === "view" ? "24px" : "8px",
                        }}
                      >
                        Tags
                      </label>
                      <div style={{ flex: 1 }}>
                        {mode !== "view" ? (
                          <Select
                            mode="multiple"
                            style={{ width: "100%" }}
                            placeholder="Type and press enter to create or select a tag"
                            labelInValue
                            onDeselect={(e: {
                              label: string;
                              value: string | number;
                            }) => {
                              if (typeof e?.value === "number") {
                                setDeselectedTags((pre) => {
                                  return [...pre, e.value];
                                });
                              }
                            }}
                            value={tags}
                            onSearch={debouncedFetch}
                            onDropdownVisibleChange={(open) => {
                              if (open && projectTagsList?.length > 0) {
                                fetchTagSuggestions("");
                              }
                            }}
                            onChange={(value) => {
                              const latest: any = value?.slice(-1)[0]; // Get the last tag
                              if (latest?.label?.length < 2) {
                                // Check if the last tag length is less than 2 characters
                                messageApi.open({
                                  type: "error",
                                  content: "Enter at least 2 characters",
                                  duration: 5,
                                });
                                setOptions([]);
                                return;
                              }
                              setTags(value);
                            }}
                            options={options}
                            tokenSeparators={[","]}
                            tagRender={tagRender}
                            filterOption={false} // Use custom filtering only
                          />
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              minHeight: "32px",
                              fontSize: "0.875rem",
                            }}
                          >
                            {tags && tags.length > 0 ? (
                              tags.map((tag: any, index: number) => {
                                const color = getColorByLabel(
                                  (tag.label || "").toString()
                                );
                                return (
                                  <span
                                    key={index}
                                    className="custom-tag-wrapper"
                                  >
                                    <Tag
                                      className="custom-tag"
                                      style={{ backgroundColor: color }}
                                    >
                                      {tag.label}
                                    </Tag>
                                    <span
                                      className="custom-tag-tail"
                                      style={{ borderLeftColor: color }}
                                    />
                                  </span>
                                );
                              })
                            ) : (
                              <span style={{ color: "#526484" }}>N/A</span>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row g-3 ">
            <Col lg="12">
              <label className="form-label">Tags</label>
              <Select
                mode="multiple"
                style={{ width: "100%" }}
                placeholder="Type and press enter to create or select a tag"
                disabled={mode === "view"}
                labelInValue
                onDeselect={(e: { label: string; value: string | number }) => {
                  if (typeof e?.value === "number") {
                    setDeselectedTags((pre) => {
                      return [...pre, e.value];
                    });
                  }
                }}
                value={tags}
                onSearch={debouncedFetch}
                onChange={(value) => {
                  const latest: any = value?.slice(-1)[0]; // Get the last tag

                  if (latest?.label?.length < 2) {
                    // Check if the last tag length is less than 2 characters
                    messageApi.open({
                      type: "error",
                      content: "Enter at least 2 characters",
                      duration: 5,
                    });
                    setOptions([]);
                    return;
                  }
                  setTags(value);
                }}
                options={options}
                tokenSeparators={[","]}
                tagRender={tagRender}
                filterOption={false} // Use custom filtering only
              />
            </Col>
          </div> */}
            <CollapsePanel mode={mode} />
          </form>
        </FormProvider>
        <Modal
          maskClosable={false}
          title={resourceModal?.title}
          animation={false}
          open={resourceModal?.open}
          footer={null}
          width={"90%"}
          onCancel={() => {
            setResourceModal((pre) => ({
              ...pre,
              open: false,
            }));
          }}
        >
          <FormProvider {...resourcesMethods}>
            <form>
              <div className={` mb-2 p-0 `}>
                <div
                  style={{
                    minHeight: "120px",
                  }}
                >
                  <Row className="w-100 mt-1 mb-1">
                    <Col lg="6">
                      <FormSelect
                        name={`laborTypeId`}
                        label="Labour Type"
                        options={labourTypesList}
                        placeholder="Select Labour Type"
                        required={true}
                        onChange={(e, option) => {
                          resourcesSetValue("labourTypeName", option?.label);
                        }}
                      />
                    </Col>
                    <Col lg="6">
                      <FormSelect
                        name={`laborCategoryId`}
                        label="Labour Category"
                        options={laborCategoriesList}
                        placeholder="Select Labour Category"
                        required={true}
                        onChange={(e, option) => {
                          resourcesSetValue("laborCategory", option?.label);
                        }}
                      />
                    </Col>
                  </Row>
                </div>
                <Alert
                  isOpen={resourceWarning?.index !== undefined}
                  color="danger"
                  className="start-0 w-100 py-1 mt-2"
                  style={{
                    top: 0,
                    textAlign: "left",
                    fontSize: "14px",
                    cursor: "default",
                  }}
                >
                  <ReactTyped
                    strings={[resourceWarning?.message || ""]}
                    typeSpeed={15}
                    showCursor={false}
                  />
                </Alert>
                <Row className="mt-4">
                  <Col lg="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      {resourceModal?.title === "Edit Resource" ? (
                        <li>
                          <Button
                            className="btn btn-primary btn-sm"
                            type="button"
                            color="primary"
                            onClick={resourcesHandleSubmit((data: any) => {
                              const isValid =
                                fields?.length > 0
                                  ? validateResources(
                                    fields?.filter(
                                      (_: any, idx: any) =>
                                        idx != resourceModal?.index
                                    ),
                                    data
                                  )
                                  : true;
                              if (!isValid) return;

                              // Update the resource in the form array
                              update(resourceModal?.index, data);

                              // Track updated resources for API call
                              if (data?.activityResourceId) {
                                const dirtyData = getDirtyFieldsOnly(
                                  data,
                                  resourcesDirtyFields
                                );
                                // Only add to updatedResources if there are actual changes
                                if (
                                  dirtyData &&
                                  Object.keys(dirtyData).length > 0
                                ) {
                                  setUpdatedResources((pre: any) => {
                                    return {
                                      ...pre,
                                      [data?.activityResourceId]: {
                                        ...pre[data?.activityResourceId],
                                        ...dirtyData,
                                      },
                                    };
                                  });
                                }
                              }
                              resourceModalCancel();
                            })}
                          >
                            Update
                          </Button>
                        </li>
                      ) : (
                        <li>
                          <AddAccess moduleName="Activities">
                            <Button
                              className="btn btn-primary btn-sm"
                              type="button"
                              color="primary"
                              onClick={resourcesHandleSubmit((data: any) => {
                                const isValid =
                                  fields?.length > 0
                                    ? validateResources(fields, data)
                                    : true;
                                if (!isValid) return;
                                append(data);
                                resourceModalCancel();
                              })}
                            >
                              Add
                            </Button>
                          </AddAccess>
                        </li>
                      )}
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            resourceModalCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </div>
            </form>
          </FormProvider>
        </Modal>
      </div>
    </>
  );
};

export default ActivityFieldsView;
